import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import LockResetRoundedIcon from '@mui/icons-material/LockResetRounded';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useAuth } from '../auth/AuthContext';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const TrocarSenha = () => {
  const auth = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('A confirmacao precisa ser igual a nova senha.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || 'Falha ao trocar senha.');
      }

      auth.login({ token: data.token, user: data.user });
      window.location.replace('/pedidos');
    } catch (err) {
      setError(err.message || 'Falha ao trocar senha.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        background: 'linear-gradient(135deg, #111827 0%, #1f2937 48%, #f97316 100%)',
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 520, borderRadius: 4, boxShadow: '0 28px 70px rgba(15, 23, 42, 0.32)' }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: 3,
                  bgcolor: '#111827',
                  color: '#fff',
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <LockResetRoundedIcon />
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#111827' }}>
                Troque sua senha
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sua empresa acessa dados isolados no Brutos Delivery. Defina uma senha propria antes de continuar.
              </Typography>
              {auth.user?.companyLegalName ? (
                <Typography variant="caption" color="text.secondary">
                  Empresa: {auth.user.companyLegalName}
                </Typography>
              ) : null}
            </Stack>

            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2}>
                {error ? <Alert severity="error">{error}</Alert> : null}
                <TextField
                  label="Senha temporaria"
                  value={currentPassword}
                  onChange={(event) => setCurrentPassword(event.target.value)}
                  type={showPasswords ? 'text' : 'password'}
                  autoComplete="current-password"
                  fullWidth
                  required
                />
                <TextField
                  label="Nova senha"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                  type={showPasswords ? 'text' : 'password'}
                  autoComplete="new-password"
                  helperText="Use pelo menos 8 caracteres combinando letras e numeros."
                  fullWidth
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPasswords((prev) => !prev)} edge="end">
                          {showPasswords ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Confirmar nova senha"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  type={showPasswords ? 'text' : 'password'}
                  autoComplete="new-password"
                  fullWidth
                  required
                />
                <Button type="submit" size="large" variant="contained" disabled={submitting}>
                  {submitting ? 'Salvando...' : 'Salvar senha'}
                </Button>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TrocarSenha;
